import React from 'react'
import "../../CSS/Blog/Mouse.css"
import FooTer from "../footer"
import MouseEnable from "../../Images/Blog/Mouse Right Click.png"
import Mousechrome from "../../Images/Blog/Enable Chrome Extenstion For mouse click.png"



export default function MouseClick() {
    return (
        <>
            <h1 id="start">Mouse Right Click Disabled/Enabled</h1>
            <hr />
            <h1 className="hd">How To Mouse Right Click Enabled Or Disabled For Protect Your Webpage?</h1>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/6LhGvm9n8p4" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <h1 id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </h1>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) HTML<br />
                2) css<br />
                3) JS<br />
                4) Google Chrome Extension<br />
            </p>
            <h2 className="q">
                Why Mouse Right Click We Should Disabled?
            </h2>
            <p className="ans">
                Mouse Right Click Disabled for the casesensative data or pages which could be personal or could be hacked so for in this situations we can protect our website from hackers by craeting webpage which anyone couldn't be mouse right click inspact tools not be open and it will disabled.
            </p>
            <div className="zip-downloader1">
                <img id='mouseDisble' src={MouseEnable} alt="loading" />
            </div>
            <h2 className="q">
                How Mouse Right Click Enabled?
            </h2>
            <p className="ans">
                We could be do it by download Chrome Extention Or Follow the bellow stuff.
            </p>
            <h2 className="q">
                Follow The Bellow Code For enable:
            </h2>
            <p className="as">
                window.oncontextmenu = function() [
                return true
                ]
            </p>
            <div className="zip-downloader2">
                <img id='chImg' src={Mousechrome} alt="loading" />
            </div>
            <h1 className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </h1>
            <FooTer />
        </>
    )
}
